import { Button } from '../components/button'
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from './state'
import CheckBox from '../components/checkbox'
import Section from '../components/section'

export default defineComponent({
  name: 'page.stage4',
  setup () {
    const store = useStore()
    const router = useRouter()

    store.initStage(4)

    const goToNext = async () => {
      if (store.stageValidity !== true) return
      router.push({
        name: 'stage5',
      })
    }

    return () => [
      <div class="py-20">
        <Section onlyMobile={false}>
          <div class="text-[#245058] basis-full font-bold text-3xl text-center">
            설문참여를 위해 정보를 입력해주세요
          </div>
        </Section>
        {/* 결혼 */}
        <Section onlyMobile={false} class="mt-12">
          <div class="text-xl text-center basis-full">결혼유무</div>
        </Section>
        <Section onlyMobile={true}>
          <div class="basis-1/2 pr-2">
            <CheckBox
              label="기혼"
              value="true"
              active={store.결혼유무 === '기혼'}
              onSelect={() => (store.결혼유무 = '기혼')}
            />
          </div>
          <div class="basis-1/2 pl-2">
            <CheckBox
              label="미혼"
              value="false"
              active={store.결혼유무 === '미혼'}
              onSelect={() => (store.결혼유무 = '미혼')}
            />
          </div>
        </Section>
        {/* 성별 */}
        <Section onlyMobile={false} class="mt-12">
          <div class="text-xl text-center basis-full">성별</div>
        </Section>
        <Section onlyMobile={true}>
          <div class="basis-1/2 pr-2">
            <CheckBox
              label="남성"
              value="남성"
              active={store.성별 === '남성'}
              onSelect={() => (store.성별 = '남성')}
            />
          </div>
          <div class="basis-1/2 pl-2">
            <CheckBox
              label="여성"
              value="여성"
              active={store.성별 === '여성'}
              onSelect={() => (store.성별 = '여성')}
            />
          </div>
        </Section>
        {/* 직업군 */}
        <Section onlyMobile={false} class="mt-12">
          <div class="text-xl text-center basis-full">직업군</div>
        </Section>
        <Section onlyMobile={true}>
          <div class="basis-full">
            <select
              value={store.직업군}
              placeholder="직업군을 선택해주세요"
              class="border border-[#dbdbdb] rounded-md px-4 py-2 w-full"
              onInput={(e) => {
                store.직업군 = (e.target as HTMLSelectElement).value
              }}
            >
              <option value="" selected disabled>
                직업군을 선택해주세요
              </option>
              <option value="자영업">자영업</option>
              <option value="학생">학생</option>
              <option value="주부">주부</option>
              <option value="무직/준비중">무직/준비중</option>
              <option value="직장인">직장인</option>
              <option value="기타">기타</option>
            </select>
          </div>
        </Section>
        <Section onlyMobile={true}>
          <Button
            class="w-full"
            disabled={!store.stageValidity}
            onClick={goToNext}
          >
            계속
          </Button>
        </Section>
      </div>,
    ]
  },
})
